import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //src: 'https://localhost:44320',
    //subDirectory: '',
    // src: 'https://tavis.tw/gma/36th',
    // subDirectory: '/Platform',
    src: 'https://tavis.tw/gma/36th',
    subDirectory: '',
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
